import axios from "./AxiosService";

export function getHealthTerms() {
  return axios
    .get("healthinformation")
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}

export function getHealthRecommendations(healthTerm, postCode) {
  return axios
    .post(
      "healthinformation?healthTerm=" + healthTerm + "&postCode=" + postCode
    )
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
}
